import React, { useEffect, useState, useRef } from 'react';
import { useLocation, Link , useNavigate  } from "react-router-dom";
import ModalFavori from "./ModalFavori";

function Header({ forceScrolled = false }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [collections, setCollections] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [produitsDropdownOpen, setProduitsDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(forceScrolled);
  const dropdownRef = useRef(null);
  const produitsDropdownRef = useRef(null);
  const [showFavorisModal, setShowFavorisModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [favorisCount, setFavorisCount] = useState(0);

  const productCategories = [
    { name: 'Papier peint', url: '/collections/papierpeint' },
    { name: 'Posters', url: '/collections/poster' },
    { name: 'Bardage', url: '/collections/bardage' },
    { name: 'Effet moulure', url: '/collections/moulure' },
    { name: 'Coussins & Poufs', url: '/collections/coussinsETpoufs' },
    { name: 'Accessoires', url: '/collections/accessoires' },
  ];

   const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
    setMenuOpen(false);
  };

  useEffect(() => {
    function updateCount() {
      const favs = JSON.parse(localStorage.getItem("adawall_favorites") || "[]");
      setFavorisCount(favs.length);
    }
    updateCount();
    window.addEventListener("storage", updateCount);
    return () => window.removeEventListener("storage", updateCount);
  }, [showFavorisModal, location]);

  // Charger les collections pour "Papier peint"
  useEffect(() => {
    fetch('https://adawall.ma/php/api/collection.php')
      .then((res) => res.json())
      .then((data) => setCollections(data))
      .catch(() => setCollections([]));
  }, []);

  // Fermer dropdowns et menu hamburger si clic en dehors ou sur un lien
  useEffect(() => {
    function handleClickOutside(event) {
      // Dropdowns
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (
        produitsDropdownRef.current &&
        !produitsDropdownRef.current.contains(event.target)
      ) {
        setProduitsDropdownOpen(false);
      }
      // Menu hamburger
      const nav = document.querySelector('nav.open');
      if (
        nav &&
        !nav.contains(event.target) &&
        !event.target.classList.contains('hamburger')
      ) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fermer le menu hamburger quand on clique sur un lien du menu
  const handleMenuLinkClick = () => setMenuOpen(false);

  // Gestion du scroll pour header-scrolled et forceScrolled
  useEffect(() => {
    if (forceScrolled) {
      setScrolled(true);
    }
  }, [forceScrolled]);

  useEffect(() => {
    if (forceScrolled) return;
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [forceScrolled]);

  const toggleDropdown = () => setDropdownOpen((open) => !open);
  const toggleProduitsDropdown = () => setProduitsDropdownOpen((open) => !open);

  const pathname = location.pathname;

  return (
    <header className={`header${scrolled ? " header-scrolled" : ""}`}>
      <div className="header-content">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={handleLogoClick}>
            <img src="/assets/logo/logo blanc.png" alt="Adawall Maroc" />
          </Link>
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={() => setMenuOpen((open) => !open)}>
          <span />
          <span />
          <span />
        </div>

        {/* Navigation */}
        <nav className={menuOpen ? "open" : ""}>
          {/* Dropdown Papier peint */}
          <div className="dropdown" ref={dropdownRef}>
            <button onClick={toggleDropdown}>
              PAPIER PEINT ▾
            </button>
            {dropdownOpen && (
              <div className="dropdown-menu">
                {collections.length > 0 ? (
                  collections
                    .filter(col => col.nomCategorie && col.nomCategorie.toLowerCase() === "wallpapers")
                    .map((col) => (
                      <Link
                        key={col.idCollection}
                        to={`/collections/${col.idCollection}`}
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}
                        onClick={() => {
                          setDropdownOpen(false);
                          handleMenuLinkClick();
                        }}
                      >
                        <span>{col.nomCollection}</span>
                        <span style={{ color: '#888', fontSize: '0.9em' }}>{col.description}  </span>
                      </Link>
                    ))
                ) : (
                  <div>Aucune collection trouvée</div>
                )}
              </div>
            )}
          </div>

          {/* Dropdown Produits */}
          <div className="dropdown produits" ref={produitsDropdownRef}>
            <button onClick={toggleProduitsDropdown}>
              PRODUITS ▾
            </button>
            {produitsDropdownOpen && (
              <div className="dropdown-menu">
                {productCategories.map((cat, index) => (
                  <Link
                    key={index}
                    to={cat.url}
                    onClick={() => {
                      setProduitsDropdownOpen(false);
                      handleMenuLinkClick();
                    }}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Autres liens */}
          <Link
            to="/projets"
            className={pathname === "/projets" ? "active" : ""}
            onClick={handleMenuLinkClick}
          >
            PROJETS
          </Link>
          <Link
            to="/a-propos"
            className={pathname === "/a-propos" ? "active" : ""}
            onClick={handleMenuLinkClick}
          >
            À PROPOS
          </Link>
          <Link
            to="/contact"
            className={pathname === "/contact" ? "active" : ""}
            onClick={handleMenuLinkClick}
          >
            CONTACT
          </Link>

          {/* Cœur Favoris */}
          <a
            href="#"
            className="header-fav-link"
            title="Voir mes favoris"
            style={{ marginLeft: 18, display: "flex", alignItems: "center", position: "relative" }}
            onClick={(e) => { e.preventDefault(); setShowFavorisModal(true); handleMenuLinkClick(); }}
          >
            {/* Badge compteur */}
            {favorisCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -3,
                  left: -1,
                  background: "#96292A",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 22,
                  height: 22,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  fontWeight: 700,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.13)",
                  zIndex: 2
                }}
              >
                {favorisCount}
              </span>
            )}
            <i className="fa-regular fa-heart" style={{ fontSize: 24, color: "#ffffffff" }}></i>
          </a>
        </nav>
      </div>

      {/* Modal Favoris */}
      <ModalFavori open={showFavorisModal} onClose={() => setShowFavorisModal(false)} />
    </header>
  );
}
export default Header;